import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React from "react";

const FlowImg = require("../../Assets/Images/Flow.png");
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    display: "flex",
    fontFamily: "Lato",
    padding: "20px",
  },
  topSection: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  coverTitle: {
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "30px",
    color: "#426B88",
    fontFamily: "Lato",
    textAlign: "left",
  },
  contentContainer: {
    textAlign: "left",
    maxWidth: "800px",
    marginTop: "10px",
  },
  highlightText: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    fontFamily: "Lato",
  },
  paragraph: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "10px",
    marginTop: "5px",
  },
  textContent: {
    width: "55%",
  },
  secondsection: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    fontFamily: "Lato",
  },
  chartcontainer: {
    padding: 5,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  title: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "35px",
    color: "#426B88",
    fontFamily: "Lato",
    marginHorizontal: 120,
  },
  imageContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  coverImage: {
    width: "194px",
    height: "229px",
    marginHorizontal: 10,
  },
  separator: {
    border: "1px solid #000000",
    backgroundColor: "#000000",
  },
  heading: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  headingtitle: {
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "18px",
    color: "#426B88",
    fontFamily: "Lato",
    marginHorizontal: 50,
  },
});

const QuadrantFlowFirstPage360 = () => {
  return (
    <View style={styles.coverSection}>
      <View style={styles.topSection}>
        <View style={styles.textContent}>
          <Text style={styles.coverTitle}>YOUR QUADRANT FLOW</Text>
        </View>
      </View>
      <View style={styles.contentContainer}>
        <Text style={styles.paragraph}>
          Quadrant Flow is a dynamic concept in personal development and
          performance. It focuses on how your energy flows from one of four
          foundational quadrants—Heart, Soul, Mind, or Strength.
        </Text>
        <Text style={styles.paragraph}>
          Unlike typical assessments that tend to categorize individuals into
          rigid types, Quadrant Flow recognizes that everyone embodies elements
          of all four quadrants. The primary quadrant is a starting point, not a
          constraint. The flow from one quadrant to another offers a more
          holistic view of who you are and how you lead.
        </Text>
        <Text style={styles.paragraph}>
          Interestingly, the last quadrant individuals flow into often
          represents a weakness or blind spot. However, Quadrant Flow perceives
          this not as a deficiency but as an area for potential growth and
          learning. It may indicate a vulnerability, a lack of awareness, or an
          aspect of oneself that has not been fully recognized or valued.
          Understanding and embracing this last quadrant can be a powerful
          personal and group development tool, offering a more balanced and
          comprehensive self-awareness pathway.
        </Text>
        <Text style={styles.paragraph}>
          The Quadrant Flow journey reflects the intricate tapestry of human
          relationships and personalities. The world, as we know, is complex and
          multi-faceted. Our endeavor is not to oversimplify this complexity but
          to shed light on the nuances of the human condition without stripping
          away its inherent beauty and mystery. By gaining a deeper
          understanding of ourselves and others, we reduce conflict, judgment,
          and confusion and pave the way for greater appreciation,
          collaboration, and respect.
        </Text>
        <View style={styles.secondsection}>
          <View style={styles.chartcontainer}>
            <View style={styles.header}>
              <Text style={styles.title}>SELF</Text>
              <Text style={styles.title}>360</Text>
            </View>
            <View style={styles.imageContainer}>
              <Image src={FlowImg} style={styles.coverImage} />
              <View style={styles.separator} />
              <Image src={FlowImg} style={styles.coverImage} />
            </View>
            <View style={styles.heading}>
              <Text style={styles.headingtitle}>
                YOU FLOW FROM HEART TO SOUL
              </Text>
              <Text style={styles.headingtitle}>
                YOU FLOW FROM HEART TO SOUL
              </Text>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default QuadrantFlowFirstPage360;
